import type { IconDefinition } from '../index.tsx';

export const iconImage: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconImage',
  icon: [
    16,
    16,
    [],
    '',
    'M1 1H15V15H1V1ZM6 9L8 11L13 6V13H3V12L6 9ZM6.5 7C7.32843 7 8 6.32843 8 5.5C8 4.67157 7.32843 4 6.5 4C5.67157 4 5 4.67157 5 5.5C5 6.32843 5.67157 7 6.5 7Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
